// import { persistSessionId, hydrateLocalData } from "../PersistActions";
// import { REDUCER_TYPE } from '../../Reducers/express/LoginRedux';

export const appStart = () => [
  // persistSessionId(),
  // hydrateLocalData([REDUCER_TYPE]),
  // add other actions if needed
];
